<section class="flex p-3 bg-white">
  <app-attendee-city-autocomplete
    class="flex-1"
    [label]="'attendee.filters.city.input.label' | translate"
    [placeholder]="'attendee.filters.city.input.placeholder' | translate"
    [inputStyle]="inputStyle.Transparent"
    (selectedPlace)="selectPlace($event)"
    (selectedRadius)="selectRadius($event)"
    (isCleared)="handleAutocompleteClear()"
    [defaultPlaceValue]="city"
    [defaultPlaceId]="placeId"
    [defaultRadiusValue]="radius"
  ></app-attendee-city-autocomplete>

  <app-attendee-sports-groups-autocomplete
    class="flex-1 ml-3"
    [label]="'attendee.filters.sport.input.label' | translate"
    [placeholder]="'attendee.filters.sport.input.placeholder' | translate"
    [inputStyle]="inputStyle.Transparent"
    (selected)="selectSportsGroup($event)"
    [selectedIdentifier]="sportsGroup"
    data-test="search-sports"
  ></app-attendee-sports-groups-autocomplete>

  <app-attendee-date-range-input
    class="flex-1 ml-3"
    [label]="'attendee.filters.date_range.input.label' | translate"
    [placeholder]="'attendee.filters.date_range.input.placeholder' | translate"
    [inputStyle]="inputStyle.Transparent"
    (selected)="selectDateRange($event)"
    [defaultFrom]="dateRange?.from"
    [defaultTo]="dateRange?.to"
    (resetDateFilter)="updateFilter($event)"
  ></app-attendee-date-range-input>

  <button
    *ngIf="!isSearchAuto"
    app-vtmn-play-button
    type="button"
    (click)="search()"
    class="top-3 ml-3"
    data-test="search"
  >
    {{ 'attendee.filters.button.search' | translate }}
  </button>
</section>
